import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";

import { keys } from "./constants";

export const useInvalidatePetFilterOptions = () => {
  const queryClient = useQueryClient();
  return useCallback(() => {
    queryClient.invalidateQueries({ queryKey: keys.search() });
    queryClient.invalidateQueries({ queryKey: keys.rebateItemLists() });
    queryClient.invalidateQueries({ queryKey: keys.incentiveItemLists() });
  }, [queryClient]);
};

export const useInvalidateProductLines = () => {
  const queryClient = useQueryClient();
  return useCallback(
    () => queryClient.invalidateQueries({ queryKey: keys.productLines() }),
    [queryClient],
  );
};
